import { render, staticRenderFns } from "./reporte-accidentes.vue?vue&type=template&id=83192e62&scoped=true&"
import script from "./reporte-accidentes.vue?vue&type=script&lang=js&"
export * from "./reporte-accidentes.vue?vue&type=script&lang=js&"
import style0 from "./reporte-accidentes.vue?vue&type=style&index=0&id=83192e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83192e62",
  null
  
)

export default component.exports